// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CollectionCsvSubmissionRequest,
    CollectionIntegration,
    CollectionPatientAccount,
    CollectionPatientAccountSortType,
    CollectionPatientAccountStatement,
    CollectionPatientAccountStatementDetails,
    CollectionPatientAccountStatementSortType,
    CollectionPaymentSourceCsvImportRequest,
    CollectionWorkflowSubmission,
    CollectionsCsvExportRequest,
    CreateCollectionPatientAccountStatementRequest,
    CreateCollectionPatientAccountStatementResponse,
    CreateCollectionRefundWorkflowRequestPayload,
    CreateCollectionWorkflowHoldPayload,
    CsvExportItemDocumentResponse,
    CsvExportItemResponse,
    ObjectNoResponse,
    ProviderAllocateCollectionPaymentSourceListPayload,
    ProviderCollectionPayment,
    ProviderCollectionPaymentSortType,
    ProviderCollectionPaymentSource,
    ProviderCollectionPaymentSourceSortType,
    ProviderCollectionPaymentSourceWithAllocationInfo,
    ProviderCollectionRefundRequest,
    ProviderCollectionRefundRequestSortType,
    ProviderCreateCollectionPaymentPayload,
    ProviderCreateCollectionPaymentSourcePayload,
    ProviderCreatePatientCreditCardPayload,
    ProviderPaymentPlan,
    ProviderPaymentPlanSortType,
    ProviderRefundCollectionPaymentPayload,
    ProviderRefundRequestNotesPayload,
    ProviderUpdateCollectionPaymentPayload,
    RemoveCollectionWorkflowHoldPayload,
    StripeConfigurationResponse,
    SubmissionReportDocumentUrlResponse,
    SupportCollectionInboxOperation,
    SupportCollectionInboxOperationRequest,
    SupportCollectionInvoiceEvent,
    SupportCollectionInvoiceEventSortType,
    SupportCollectionPayment,
    SupportCreateCollectionPatientAccountStatementRequest,
    SupportCreateCollectionPaymentPayload,
    SupportCreatePaymentPlanPayload,
    SupportPaymentPlan,
    SupportPaymentPlanSortType,
    SupportRefundCollectionPaymentPayload,
    SupportWorkflowMessageLinkRequest,
    WorkflowApproveActionRequest,
    WorkflowDenyActionRequest,
    WorkflowHold,
    WorkflowHoldSortType,
    WorkflowRequest,
    WorkflowRequestSortType,
    WorkflowSubmissionReportItemResponse,
    WorkflowSubmissionReportResponse,
    WorkflowSubmissionReportSortType,
    WorkflowSubmissionSortType,
    CollectionCsvSubmissionRequestToJSON,
    CollectionPaymentSourceCsvImportRequestToJSON,
    CollectionsCsvExportRequestToJSON,
    CreateCollectionPatientAccountStatementRequestToJSON,
    CreateCollectionRefundWorkflowRequestPayloadToJSON,
    CreateCollectionWorkflowHoldPayloadToJSON,
    ProviderAllocateCollectionPaymentSourceListPayloadToJSON,
    ProviderCreateCollectionPaymentPayloadToJSON,
    ProviderCreateCollectionPaymentSourcePayloadToJSON,
    ProviderCreatePatientCreditCardPayloadToJSON,
    ProviderRefundCollectionPaymentPayloadToJSON,
    ProviderRefundRequestNotesPayloadToJSON,
    ProviderUpdateCollectionPaymentPayloadToJSON,
    RemoveCollectionWorkflowHoldPayloadToJSON,
    SupportCollectionInboxOperationRequestToJSON,
    SupportCreateCollectionPatientAccountStatementRequestToJSON,
    SupportCreateCollectionPaymentPayloadToJSON,
    SupportCreatePaymentPlanPayloadToJSON,
    SupportRefundCollectionPaymentPayloadToJSON,
    SupportWorkflowMessageLinkRequestToJSON,
    WorkflowApproveActionRequestToJSON,
    WorkflowDenyActionRequestToJSON,
    CollectionIntegrationFromJSON,
    CollectionPatientAccountFromJSON,
    CollectionPatientAccountStatementFromJSON,
    CollectionPatientAccountStatementDetailsFromJSON,
    CollectionWorkflowSubmissionFromJSON,
    CreateCollectionPatientAccountStatementResponseFromJSON,
    CsvExportItemDocumentResponseFromJSON,
    CsvExportItemResponseFromJSON,
    ObjectNoResponseFromJSON,
    ProviderCollectionPaymentFromJSON,
    ProviderCollectionPaymentSourceFromJSON,
    ProviderCollectionPaymentSourceWithAllocationInfoFromJSON,
    ProviderCollectionRefundRequestFromJSON,
    ProviderPaymentPlanFromJSON,
    StripeConfigurationResponseFromJSON,
    SubmissionReportDocumentUrlResponseFromJSON,
    SupportCollectionInboxOperationFromJSON,
    SupportCollectionInvoiceEventFromJSON,
    SupportCollectionPaymentFromJSON,
    SupportPaymentPlanFromJSON,
    WorkflowHoldFromJSON,
    WorkflowRequestFromJSON,
    WorkflowSubmissionReportItemResponseFromJSON,
    WorkflowSubmissionReportResponseFromJSON,
} from '../models';

export interface ApproveProviderRefundRequestRequest {
    id: string;
    providerRefundRequestNotesPayload: ProviderRefundRequestNotesPayload;
}

export interface CreateProviderPatientCreditCardRequest {
    providerCreatePatientCreditCardPayload: ProviderCreatePatientCreditCardPayload;
}

export interface DenyProviderRefundRequestRequest {
    id: string;
    providerRefundRequestNotesPayload: ProviderRefundRequestNotesPayload;
}

export interface DisableProviderCollectionPaymentPlanRequest {
    id: string;
}

export interface DisableSupportCollectionPaymentPlanRequest {
    id: string;
}

export interface GetProviderCollectionPatientAccountByIdRequest {
    id: string;
}

export interface GetProviderCollectionPatientAccountStatementByIdRequest {
    id: string;
}

export interface GetProviderCollectionPatientAccountStatementDetailsByIdRequest {
    id: string;
}

export interface GetProviderCollectionPatientAccountStatementsRequest {
    filterCollectionPatientAccountId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderCollectionPatientAccountStatementsOrderEnum>;
    sort?: Array<CollectionPatientAccountStatementSortType>;
}

export interface GetProviderCollectionPatientAccountsRequest {
    filterCollectionIntegrationId?: Array<string>;
    filterExternalPatientId?: Array<string>;
    order?: Array<GetProviderCollectionPatientAccountsOrderEnum>;
    limit?: number;
    offset?: number;
    sort?: Array<CollectionPatientAccountSortType>;
}

export interface GetProviderCollectionPaymentRequest {
    id: string;
}

export interface GetProviderCollectionPaymentPlanRequest {
    id: string;
}

export interface GetProviderCollectionWorkflowHoldsRequest {
    filterEventType?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterRemoveDate?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderCollectionWorkflowHoldsOrderEnum>;
    sort?: Array<WorkflowHoldSortType>;
}

export interface GetProviderCollectionWorkflowRequestsRequest {
    filterEventType?: Array<string>;
    filterWorkflowSubmissionId?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterActionActorType?: Array<string>;
    filterActionType?: Array<string>;
    filterRequestAmount?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterCollectionPatientAccountId?: Array<string>;
    filterCreated?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderCollectionWorkflowRequestsOrderEnum>;
    sort?: Array<WorkflowRequestSortType>;
}

export interface GetProviderCollectionWorkflowSubmissionReportFileRequest {
    id: string;
    rid: string;
}

export interface GetProviderCollectionWorkflowSubmissionReportsRequest {
    id: string;
    filterId?: Array<string>;
    filterReportType?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderCollectionWorkflowSubmissionReportsOrderEnum>;
    sort?: Array<WorkflowSubmissionReportSortType>;
}

export interface GetProviderCollectionWorkflowSubmissionsRequest {
    filterEventType?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterExecutionType?: Array<string>;
    filterSubmissionStartDate?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterCreated?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderCollectionWorkflowSubmissionsOrderEnum>;
    sort?: Array<WorkflowSubmissionSortType>;
}

export interface GetProviderPatientCollectionCsvExportRequest {
    id: string;
}

export interface GetSupportCollectionPatientAccountByIdRequest {
    id: string;
}

export interface GetSupportCollectionPatientAccountStatementByIdRequest {
    id: string;
}

export interface GetSupportCollectionPatientAccountStatementDetailsByIdRequest {
    id: string;
}

export interface GetSupportCollectionPatientAccountStatementsRequest {
    filterCollectionPatientAccountId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportCollectionPatientAccountStatementsOrderEnum>;
    sort?: Array<CollectionPatientAccountStatementSortType>;
}

export interface GetSupportCollectionPatientAccountsRequest {
    filterCollectionIntegrationId?: Array<string>;
    filterExternalPatientId?: Array<string>;
    order?: Array<GetSupportCollectionPatientAccountsOrderEnum>;
    limit?: number;
    offset?: number;
    sort?: Array<CollectionPatientAccountSortType>;
}

export interface GetSupportCollectionPaymentRequest {
    id: string;
}

export interface GetSupportCollectionPaymentPlanRequest {
    id: string;
}

export interface GetSupportCollectionWorkflowHoldsRequest {
    filterEventType?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterRemoveDate?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportCollectionWorkflowHoldsOrderEnum>;
    sort?: Array<WorkflowHoldSortType>;
}

export interface GetSupportCollectionWorkflowRequestsRequest {
    filterEventType?: Array<string>;
    filterWorkflowSubmissionId?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterActionActorType?: Array<string>;
    filterActionType?: Array<string>;
    filterRequestAmount?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterCollectionPatientAccountId?: Array<string>;
    filterCreated?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportCollectionWorkflowRequestsOrderEnum>;
    sort?: Array<WorkflowRequestSortType>;
}

export interface GetSupportCollectionWorkflowSubmissionReportFileRequest {
    id: string;
    rid: string;
}

export interface GetSupportCollectionWorkflowSubmissionReportsRequest {
    id: string;
    filterId?: Array<string>;
    filterReportType?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportCollectionWorkflowSubmissionReportsOrderEnum>;
    sort?: Array<WorkflowSubmissionReportSortType>;
}

export interface GetSupportCollectionWorkflowSubmissionsRequest {
    filterEventType?: Array<string>;
    filterCollectionIntegrationId?: Array<string>;
    filterExecutionType?: Array<string>;
    filterSubmissionStartDate?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterCreated?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportCollectionWorkflowSubmissionsOrderEnum>;
    sort?: Array<WorkflowSubmissionSortType>;
}

export interface GetSupportPatientCollectionCsvExportDownloadRequest {
    id: string;
}

export interface ListProviderCollectionPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCollectionPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterInvoiceId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterClaimId?: Array<string>;
    sort?: Array<ProviderPaymentPlanSortType>;
}

export interface ListProviderCollectionPaymentSourcesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCollectionPaymentSourcesOrderEnum>;
    filterCreated?: Array<string>;
    filterPaymentDate?: Array<string>;
    filterUnallocatedAmount?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterExternalTransactionId?: Array<string>;
    filterExternalVisitId?: Array<string>;
    sort?: Array<ProviderCollectionPaymentSourceSortType>;
}

export interface ListProviderCollectionPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderCollectionPaymentsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterCollectionPaymentSourceId?: Array<string>;
    filterClaimType?: ListProviderCollectionPaymentsFilterClaimTypeEnum;
    sort?: Array<ProviderCollectionPaymentSortType>;
}

export interface ListProviderRefundRequestsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderRefundRequestsOrderEnum>;
    filterCreated?: Array<string>;
    filterPatientId?: Array<string>;
    filterExternalPatientId?: Array<string>;
    filterApproveDate?: Array<string>;
    filterDenyDate?: Array<string>;
    filterCollectionSubmissionId?: Array<string>;
    filterReconcileDate?: Array<string>;
    sort?: Array<ProviderCollectionRefundRequestSortType>;
}

export interface ListSupportCollectionInvoiceEventsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCollectionInvoiceEventsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    sort?: Array<SupportCollectionInvoiceEventSortType>;
}

export interface ListSupportCollectionPaymentPlansRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCollectionPaymentPlansOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    sort?: Array<SupportPaymentPlanSortType>;
}

export interface ListSupportCollectionPaymentsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportCollectionPaymentsOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterGuarantorId?: Array<string>;
    filterClaimType?: ListSupportCollectionPaymentsFilterClaimTypeEnum;
    sort?: Array<ProviderCollectionPaymentSortType>;
}

export interface PatchProviderUpdateCollectionPaymentRequest {
    id: string;
    providerUpdateCollectionPaymentPayload: ProviderUpdateCollectionPaymentPayload;
}

export interface PostExecuteSupportCollectionInboxOperationRequest {
    id: string;
}

export interface PostProviderAllocateCollectionPaymentSourceRequest {
    id: string;
    providerAllocateCollectionPaymentSourceListPayload: ProviderAllocateCollectionPaymentSourceListPayload;
}

export interface PostProviderCollectionPatientAccountStatementRequest {
    createCollectionPatientAccountStatementRequest: CreateCollectionPatientAccountStatementRequest;
}

export interface PostProviderCollectionPaymentRefundRequest {
    id: string;
    providerRefundCollectionPaymentPayload: ProviderRefundCollectionPaymentPayload;
}

export interface PostProviderCollectionPaymentSourceCsvImportRequest {
    collectionPaymentSourceCsvImportRequest: CollectionPaymentSourceCsvImportRequest;
}

export interface PostProviderCollectionRefundWorkflowRequestCreateRequest {
    id: string;
    createCollectionRefundWorkflowRequestPayload: CreateCollectionRefundWorkflowRequestPayload;
}

export interface PostProviderCollectionWorkflowHoldCreateRequest {
    createCollectionWorkflowHoldPayload: CreateCollectionWorkflowHoldPayload;
}

export interface PostProviderCollectionWorkflowHoldRemoveRequest {
    id: string;
    removeCollectionWorkflowHoldPayload: RemoveCollectionWorkflowHoldPayload;
}

export interface PostProviderCollectionWorkflowRequestApproveRequest {
    id: string;
    workflowApproveActionRequest: WorkflowApproveActionRequest;
}

export interface PostProviderCollectionWorkflowRequestDenyRequest {
    id: string;
    workflowDenyActionRequest: WorkflowDenyActionRequest;
}

export interface PostProviderCollectionWorkflowSubmissionPreviewRequest {
    id: string;
}

export interface PostProviderCollectionWorkflowSubmissionSubmitRequest {
    id: string;
}

export interface PostProviderCreateCollectionPaymentRequest {
    providerCreateCollectionPaymentPayload: ProviderCreateCollectionPaymentPayload;
}

export interface PostProviderCreateCollectionPaymentSourceRequest {
    providerCreateCollectionPaymentSourcePayload: ProviderCreateCollectionPaymentSourcePayload;
}

export interface PostProviderPatientCollectionCsvExportRequest {
    collectionsCsvExportRequest: CollectionsCsvExportRequest;
}

export interface PostProviderPaymentPlanRequest {
    supportCreatePaymentPlanPayload: SupportCreatePaymentPlanPayload;
}

export interface PostSupportCollectionInboxOperationRequest {
    supportCollectionInboxOperationRequest: SupportCollectionInboxOperationRequest;
}

export interface PostSupportCollectionPatientAccountStatementRequest {
    supportCreateCollectionPatientAccountStatementRequest: SupportCreateCollectionPatientAccountStatementRequest;
}

export interface PostSupportCollectionPaymentDisableRequest {
    id: string;
}

export interface PostSupportCollectionPaymentRefundRequest {
    id: string;
    supportRefundCollectionPaymentPayload: SupportRefundCollectionPaymentPayload;
}

export interface PostSupportCollectionRefundWorkflowRequestCreateRequest {
    id: string;
    createCollectionRefundWorkflowRequestPayload: CreateCollectionRefundWorkflowRequestPayload;
}

export interface PostSupportCollectionWorkflowHoldCreateRequest {
    createCollectionWorkflowHoldPayload: CreateCollectionWorkflowHoldPayload;
}

export interface PostSupportCollectionWorkflowHoldRemoveRequest {
    id: string;
    removeCollectionWorkflowHoldPayload: RemoveCollectionWorkflowHoldPayload;
}

export interface PostSupportCollectionWorkflowRequestApproveRequest {
    id: string;
    workflowApproveActionRequest: WorkflowApproveActionRequest;
}

export interface PostSupportCollectionWorkflowRequestDenyRequest {
    id: string;
    workflowDenyActionRequest: WorkflowDenyActionRequest;
}

export interface PostSupportCollectionWorkflowRequestMessageLinkRequest {
    id: string;
    supportWorkflowMessageLinkRequest: SupportWorkflowMessageLinkRequest;
}

export interface PostSupportCollectionWorkflowSubmissionPreviewRequest {
    id: string;
}

export interface PostSupportCollectionWorkflowSubmissionSubmitRequest {
    id: string;
}

export interface PostSupportCreateCollectionPaymentRequest {
    supportCreateCollectionPaymentPayload: SupportCreateCollectionPaymentPayload;
}

export interface PostSupportPatientCollectionCsvExportRequest {
    collectionsCsvExportRequest: CollectionsCsvExportRequest;
}

export interface PostSupportPatientCollectionCsvSubmissionRequest {
    id: string;
    collectionCsvSubmissionRequest: CollectionCsvSubmissionRequest;
}

export interface PostSupportPaymentPlanRequest {
    supportCreatePaymentPlanPayload: SupportCreatePaymentPlanPayload;
}

export interface UnapproveProviderRefundRequestRequest {
    id: string;
}

/**
 * no description
 */
export class CollectionApi extends runtime.BaseAPI {

    /**
     * Approve the refund request
     * Approve the refund request
     */
    async approveProviderRefundRequestRaw(requestParameters: ApproveProviderRefundRequestRequest): Promise<runtime.ApiResponse<ProviderCollectionRefundRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling approveProviderRefundRequest.');
        }

        if (requestParameters['providerRefundRequestNotesPayload'] === null || requestParameters['providerRefundRequestNotesPayload'] === undefined) {
            throw new runtime.RequiredError('providerRefundRequestNotesPayload','Required parameter requestParameters.providerRefundRequestNotesPayload was null or undefined when calling approveProviderRefundRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/refund_request/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderRefundRequestNotesPayloadToJSON(requestParameters['providerRefundRequestNotesPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionRefundRequestFromJSON(jsonValue));
    }

    /**
     * Approve the refund request
     * Approve the refund request
     */
    async approveProviderRefundRequest(requestParameters: ApproveProviderRefundRequestRequest): Promise<ProviderCollectionRefundRequest> {
        const response = await this.approveProviderRefundRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a patient credit card
     * Create a patient credit card
     */
    async createProviderPatientCreditCardRaw(requestParameters: CreateProviderPatientCreditCardRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['providerCreatePatientCreditCardPayload'] === null || requestParameters['providerCreatePatientCreditCardPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreatePatientCreditCardPayload','Required parameter requestParameters.providerCreatePatientCreditCardPayload was null or undefined when calling createProviderPatientCreditCard.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:patient"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/stripe/card`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreatePatientCreditCardPayloadToJSON(requestParameters['providerCreatePatientCreditCardPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a patient credit card
     * Create a patient credit card
     */
    async createProviderPatientCreditCard(requestParameters: CreateProviderPatientCreditCardRequest): Promise<ObjectNoResponse> {
        const response = await this.createProviderPatientCreditCardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deny the refund request
     * Deny the refund request
     */
    async denyProviderRefundRequestRaw(requestParameters: DenyProviderRefundRequestRequest): Promise<runtime.ApiResponse<ProviderCollectionRefundRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling denyProviderRefundRequest.');
        }

        if (requestParameters['providerRefundRequestNotesPayload'] === null || requestParameters['providerRefundRequestNotesPayload'] === undefined) {
            throw new runtime.RequiredError('providerRefundRequestNotesPayload','Required parameter requestParameters.providerRefundRequestNotesPayload was null or undefined when calling denyProviderRefundRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/refund_request/{id}/deny`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderRefundRequestNotesPayloadToJSON(requestParameters['providerRefundRequestNotesPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionRefundRequestFromJSON(jsonValue));
    }

    /**
     * Deny the refund request
     * Deny the refund request
     */
    async denyProviderRefundRequest(requestParameters: DenyProviderRefundRequestRequest): Promise<ProviderCollectionRefundRequest> {
        const response = await this.denyProviderRefundRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableProviderCollectionPaymentPlanRaw(requestParameters: DisableProviderCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableProviderCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableProviderCollectionPaymentPlan(requestParameters: DisableProviderCollectionPaymentPlanRequest): Promise<ObjectNoResponse> {
        const response = await this.disableProviderCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableSupportCollectionPaymentPlanRaw(requestParameters: DisableSupportCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payment plan
     * Disable the payment plan
     */
    async disableSupportCollectionPaymentPlan(requestParameters: DisableSupportCollectionPaymentPlanRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of collection integrations
     * Get collection integrations
     */
    async getProviderCollectionIntegrationsRaw(): Promise<runtime.ApiResponse<Array<CollectionIntegration>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/integration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionIntegrationFromJSON));
    }

    /**
     * Retrieves a list of collection integrations
     * Get collection integrations
     */
    async getProviderCollectionIntegrations(): Promise<Array<CollectionIntegration>> {
        const response = await this.getProviderCollectionIntegrationsRaw();
        return await response.value();
    }

    /**
     * Retrieves a patient account by ID
     * Get patient account by ID
     */
    async getProviderCollectionPatientAccountByIdRaw(requestParameters: GetProviderCollectionPatientAccountByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccount>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPatientAccountById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountFromJSON(jsonValue));
    }

    /**
     * Retrieves a patient account by ID
     * Get patient account by ID
     */
    async getProviderCollectionPatientAccountById(requestParameters: GetProviderCollectionPatientAccountByIdRequest): Promise<CollectionPatientAccount> {
        const response = await this.getProviderCollectionPatientAccountByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a patient account statement by ID
     * Get patient account statement by ID
     */
    async getProviderCollectionPatientAccountStatementByIdRaw(requestParameters: GetProviderCollectionPatientAccountStatementByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccountStatement>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPatientAccountStatementById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account_statement/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountStatementFromJSON(jsonValue));
    }

    /**
     * Retrieves a patient account statement by ID
     * Get patient account statement by ID
     */
    async getProviderCollectionPatientAccountStatementById(requestParameters: GetProviderCollectionPatientAccountStatementByIdRequest): Promise<CollectionPatientAccountStatement> {
        const response = await this.getProviderCollectionPatientAccountStatementByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves detailed information about a patient account statement by ID
     * Get patient account statement details by ID
     */
    async getProviderCollectionPatientAccountStatementDetailsByIdRaw(requestParameters: GetProviderCollectionPatientAccountStatementDetailsByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccountStatementDetails>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPatientAccountStatementDetailsById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account_statement/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountStatementDetailsFromJSON(jsonValue));
    }

    /**
     * Retrieves detailed information about a patient account statement by ID
     * Get patient account statement details by ID
     */
    async getProviderCollectionPatientAccountStatementDetailsById(requestParameters: GetProviderCollectionPatientAccountStatementDetailsByIdRequest): Promise<CollectionPatientAccountStatementDetails> {
        const response = await this.getProviderCollectionPatientAccountStatementDetailsByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of patient account statements
     * Get patient account statements
     */
    async getProviderCollectionPatientAccountStatementsRaw(requestParameters: GetProviderCollectionPatientAccountStatementsRequest): Promise<runtime.ApiResponse<Array<CollectionPatientAccountStatement>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterCollectionPatientAccountId) {
            queryParameters['filterCollectionPatientAccountId'] = requestParameters.filterCollectionPatientAccountId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account_statement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionPatientAccountStatementFromJSON));
    }

    /**
     * Retrieves a list of patient account statements
     * Get patient account statements
     */
    async getProviderCollectionPatientAccountStatements(requestParameters: GetProviderCollectionPatientAccountStatementsRequest): Promise<Array<CollectionPatientAccountStatement>> {
        const response = await this.getProviderCollectionPatientAccountStatementsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of patient accounts
     * Get patient accounts
     */
    async getProviderCollectionPatientAccountsRaw(requestParameters: GetProviderCollectionPatientAccountsRequest): Promise<runtime.ApiResponse<Array<CollectionPatientAccount>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionPatientAccountFromJSON));
    }

    /**
     * Retrieves a list of patient accounts
     * Get patient accounts
     */
    async getProviderCollectionPatientAccounts(requestParameters: GetProviderCollectionPatientAccountsRequest): Promise<Array<CollectionPatientAccount>> {
        const response = await this.getProviderCollectionPatientAccountsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getProviderCollectionPaymentRaw(requestParameters: GetProviderCollectionPaymentRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getProviderCollectionPayment(requestParameters: GetProviderCollectionPaymentRequest): Promise<ProviderCollectionPayment> {
        const response = await this.getProviderCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment plan by id
     * Get collection payment plan by id
     */
    async getProviderCollectionPaymentPlanRaw(requestParameters: GetProviderCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<ProviderPaymentPlan>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Get collection payment plan by id
     * Get collection payment plan by id
     */
    async getProviderCollectionPaymentPlan(requestParameters: GetProviderCollectionPaymentPlanRequest): Promise<ProviderPaymentPlan> {
        const response = await this.getProviderCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow holds
     * Get workflow holds
     */
    async getProviderCollectionWorkflowHoldsRaw(requestParameters: GetProviderCollectionWorkflowHoldsRequest): Promise<runtime.ApiResponse<Array<WorkflowHold>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterRemoveDate) {
            queryParameters['filterRemoveDate'] = requestParameters.filterRemoveDate;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_hold`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowHoldFromJSON));
    }

    /**
     * Retrieves a list of workflow holds
     * Get workflow holds
     */
    async getProviderCollectionWorkflowHolds(requestParameters: GetProviderCollectionWorkflowHoldsRequest): Promise<Array<WorkflowHold>> {
        const response = await this.getProviderCollectionWorkflowHoldsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow requests
     * Get workflow requests
     */
    async getProviderCollectionWorkflowRequestsRaw(requestParameters: GetProviderCollectionWorkflowRequestsRequest): Promise<runtime.ApiResponse<Array<WorkflowRequest>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterWorkflowSubmissionId) {
            queryParameters['filterWorkflowSubmissionId'] = requestParameters.filterWorkflowSubmissionId;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterActionActorType) {
            queryParameters['filterActionActorType'] = requestParameters.filterActionActorType;
        }

        if (requestParameters.filterActionType) {
            queryParameters['filterActionType'] = requestParameters.filterActionType;
        }

        if (requestParameters.filterRequestAmount) {
            queryParameters['filterRequestAmount'] = requestParameters.filterRequestAmount;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterCollectionPatientAccountId) {
            queryParameters['filterCollectionPatientAccountId'] = requestParameters.filterCollectionPatientAccountId;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowRequestFromJSON));
    }

    /**
     * Retrieves a list of workflow requests
     * Get workflow requests
     */
    async getProviderCollectionWorkflowRequests(requestParameters: GetProviderCollectionWorkflowRequestsRequest): Promise<Array<WorkflowRequest>> {
        const response = await this.getProviderCollectionWorkflowRequestsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves the file for a specific workflow submission report
     * Get workflow submission report file
     */
    async getProviderCollectionWorkflowSubmissionReportFileRaw(requestParameters: GetProviderCollectionWorkflowSubmissionReportFileRequest): Promise<runtime.ApiResponse<SubmissionReportDocumentUrlResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionWorkflowSubmissionReportFile.');
        }

        if (requestParameters['rid'] === null || requestParameters['rid'] === undefined) {
            throw new runtime.RequiredError('rid','Required parameter requestParameters.rid was null or undefined when calling getProviderCollectionWorkflowSubmissionReportFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_submission/{id}/report/{rid}/file`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"rid"}}`, encodeURIComponent(String(requestParameters.rid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionReportDocumentUrlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the file for a specific workflow submission report
     * Get workflow submission report file
     */
    async getProviderCollectionWorkflowSubmissionReportFile(requestParameters: GetProviderCollectionWorkflowSubmissionReportFileRequest): Promise<SubmissionReportDocumentUrlResponse> {
        const response = await this.getProviderCollectionWorkflowSubmissionReportFileRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow submission reports
     * Get workflow submission reports
     */
    async getProviderCollectionWorkflowSubmissionReportsRaw(requestParameters: GetProviderCollectionWorkflowSubmissionReportsRequest): Promise<runtime.ApiResponse<Array<WorkflowSubmissionReportItemResponse>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderCollectionWorkflowSubmissionReports.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterReportType) {
            queryParameters['filterReportType'] = requestParameters.filterReportType;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_submission/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowSubmissionReportItemResponseFromJSON));
    }

    /**
     * Retrieves a list of workflow submission reports
     * Get workflow submission reports
     */
    async getProviderCollectionWorkflowSubmissionReports(requestParameters: GetProviderCollectionWorkflowSubmissionReportsRequest): Promise<Array<WorkflowSubmissionReportItemResponse>> {
        const response = await this.getProviderCollectionWorkflowSubmissionReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow submissions
     * Get workflow submissions
     */
    async getProviderCollectionWorkflowSubmissionsRaw(requestParameters: GetProviderCollectionWorkflowSubmissionsRequest): Promise<runtime.ApiResponse<Array<CollectionWorkflowSubmission>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExecutionType) {
            queryParameters['filterExecutionType'] = requestParameters.filterExecutionType;
        }

        if (requestParameters.filterSubmissionStartDate) {
            queryParameters['filterSubmissionStartDate'] = requestParameters.filterSubmissionStartDate;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_submission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionWorkflowSubmissionFromJSON));
    }

    /**
     * Retrieves a list of workflow submissions
     * Get workflow submissions
     */
    async getProviderCollectionWorkflowSubmissions(requestParameters: GetProviderCollectionWorkflowSubmissionsRequest): Promise<Array<CollectionWorkflowSubmission>> {
        const response = await this.getProviderCollectionWorkflowSubmissionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get patient collection export
     * Get patient collection export
     */
    async getProviderPatientCollectionCsvExportRaw(requestParameters: GetProviderPatientCollectionCsvExportRequest): Promise<runtime.ApiResponse<CsvExportItemResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPatientCollectionCsvExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/export/csv/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CsvExportItemResponseFromJSON(jsonValue));
    }

    /**
     * Get patient collection export
     * Get patient collection export
     */
    async getProviderPatientCollectionCsvExport(requestParameters: GetProviderPatientCollectionCsvExportRequest): Promise<CsvExportItemResponse> {
        const response = await this.getProviderPatientCollectionCsvExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get stripe configuration
     * Get stripe configuration
     */
    async getProviderStripeConfigurationRaw(): Promise<runtime.ApiResponse<StripeConfigurationResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:patient"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/stripe/configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Get stripe configuration
     * Get stripe configuration
     */
    async getProviderStripeConfiguration(): Promise<StripeConfigurationResponse> {
        const response = await this.getProviderStripeConfigurationRaw();
        return await response.value();
    }

    /**
     * Retrieves a list of collection integrations
     * Get collection integrations
     */
    async getSupportCollectionIntegrationsRaw(): Promise<runtime.ApiResponse<Array<CollectionIntegration>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/integration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionIntegrationFromJSON));
    }

    /**
     * Retrieves a list of collection integrations
     * Get collection integrations
     */
    async getSupportCollectionIntegrations(): Promise<Array<CollectionIntegration>> {
        const response = await this.getSupportCollectionIntegrationsRaw();
        return await response.value();
    }

    /**
     * Retrieves a patient account by ID
     * Get patient account by ID
     */
    async getSupportCollectionPatientAccountByIdRaw(requestParameters: GetSupportCollectionPatientAccountByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccount>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPatientAccountById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountFromJSON(jsonValue));
    }

    /**
     * Retrieves a patient account by ID
     * Get patient account by ID
     */
    async getSupportCollectionPatientAccountById(requestParameters: GetSupportCollectionPatientAccountByIdRequest): Promise<CollectionPatientAccount> {
        const response = await this.getSupportCollectionPatientAccountByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a patient account statement by ID
     * Get patient account statement by ID
     */
    async getSupportCollectionPatientAccountStatementByIdRaw(requestParameters: GetSupportCollectionPatientAccountStatementByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccountStatement>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPatientAccountStatementById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account_statement/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountStatementFromJSON(jsonValue));
    }

    /**
     * Retrieves a patient account statement by ID
     * Get patient account statement by ID
     */
    async getSupportCollectionPatientAccountStatementById(requestParameters: GetSupportCollectionPatientAccountStatementByIdRequest): Promise<CollectionPatientAccountStatement> {
        const response = await this.getSupportCollectionPatientAccountStatementByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves detailed information about a patient account statement by ID
     * Get patient account statement details by ID
     */
    async getSupportCollectionPatientAccountStatementDetailsByIdRaw(requestParameters: GetSupportCollectionPatientAccountStatementDetailsByIdRequest): Promise<runtime.ApiResponse<CollectionPatientAccountStatementDetails>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPatientAccountStatementDetailsById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account_statement/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionPatientAccountStatementDetailsFromJSON(jsonValue));
    }

    /**
     * Retrieves detailed information about a patient account statement by ID
     * Get patient account statement details by ID
     */
    async getSupportCollectionPatientAccountStatementDetailsById(requestParameters: GetSupportCollectionPatientAccountStatementDetailsByIdRequest): Promise<CollectionPatientAccountStatementDetails> {
        const response = await this.getSupportCollectionPatientAccountStatementDetailsByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of patient account statements
     * Get patient account statements
     */
    async getSupportCollectionPatientAccountStatementsRaw(requestParameters: GetSupportCollectionPatientAccountStatementsRequest): Promise<runtime.ApiResponse<Array<CollectionPatientAccountStatement>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterCollectionPatientAccountId) {
            queryParameters['filterCollectionPatientAccountId'] = requestParameters.filterCollectionPatientAccountId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account_statement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionPatientAccountStatementFromJSON));
    }

    /**
     * Retrieves a list of patient account statements
     * Get patient account statements
     */
    async getSupportCollectionPatientAccountStatements(requestParameters: GetSupportCollectionPatientAccountStatementsRequest): Promise<Array<CollectionPatientAccountStatement>> {
        const response = await this.getSupportCollectionPatientAccountStatementsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of patient accounts
     * Get patient accounts
     */
    async getSupportCollectionPatientAccountsRaw(requestParameters: GetSupportCollectionPatientAccountsRequest): Promise<runtime.ApiResponse<Array<CollectionPatientAccount>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionPatientAccountFromJSON));
    }

    /**
     * Retrieves a list of patient accounts
     * Get patient accounts
     */
    async getSupportCollectionPatientAccounts(requestParameters: GetSupportCollectionPatientAccountsRequest): Promise<Array<CollectionPatientAccount>> {
        const response = await this.getSupportCollectionPatientAccountsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentRaw(requestParameters: GetSupportCollectionPaymentRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPayment(requestParameters: GetSupportCollectionPaymentRequest): Promise<SupportCollectionPayment> {
        const response = await this.getSupportCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentPlanRaw(requestParameters: GetSupportCollectionPaymentPlanRequest): Promise<runtime.ApiResponse<SupportPaymentPlan>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Get collection payment by id
     * Get collection payment by id
     */
    async getSupportCollectionPaymentPlan(requestParameters: GetSupportCollectionPaymentPlanRequest): Promise<SupportPaymentPlan> {
        const response = await this.getSupportCollectionPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow holds
     * Get workflow holds
     */
    async getSupportCollectionWorkflowHoldsRaw(requestParameters: GetSupportCollectionWorkflowHoldsRequest): Promise<runtime.ApiResponse<Array<WorkflowHold>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterRemoveDate) {
            queryParameters['filterRemoveDate'] = requestParameters.filterRemoveDate;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_hold`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowHoldFromJSON));
    }

    /**
     * Retrieves a list of workflow holds
     * Get workflow holds
     */
    async getSupportCollectionWorkflowHolds(requestParameters: GetSupportCollectionWorkflowHoldsRequest): Promise<Array<WorkflowHold>> {
        const response = await this.getSupportCollectionWorkflowHoldsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow requests
     * Get workflow requests
     */
    async getSupportCollectionWorkflowRequestsRaw(requestParameters: GetSupportCollectionWorkflowRequestsRequest): Promise<runtime.ApiResponse<Array<WorkflowRequest>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterWorkflowSubmissionId) {
            queryParameters['filterWorkflowSubmissionId'] = requestParameters.filterWorkflowSubmissionId;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterActionActorType) {
            queryParameters['filterActionActorType'] = requestParameters.filterActionActorType;
        }

        if (requestParameters.filterActionType) {
            queryParameters['filterActionType'] = requestParameters.filterActionType;
        }

        if (requestParameters.filterRequestAmount) {
            queryParameters['filterRequestAmount'] = requestParameters.filterRequestAmount;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterCollectionPatientAccountId) {
            queryParameters['filterCollectionPatientAccountId'] = requestParameters.filterCollectionPatientAccountId;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowRequestFromJSON));
    }

    /**
     * Retrieves a list of workflow requests
     * Get workflow requests
     */
    async getSupportCollectionWorkflowRequests(requestParameters: GetSupportCollectionWorkflowRequestsRequest): Promise<Array<WorkflowRequest>> {
        const response = await this.getSupportCollectionWorkflowRequestsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves the file for a specific workflow submission report
     * Get workflow submission report file
     */
    async getSupportCollectionWorkflowSubmissionReportFileRaw(requestParameters: GetSupportCollectionWorkflowSubmissionReportFileRequest): Promise<runtime.ApiResponse<SubmissionReportDocumentUrlResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionWorkflowSubmissionReportFile.');
        }

        if (requestParameters['rid'] === null || requestParameters['rid'] === undefined) {
            throw new runtime.RequiredError('rid','Required parameter requestParameters.rid was null or undefined when calling getSupportCollectionWorkflowSubmissionReportFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_submission/{id}/report/{rid}/file`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"rid"}}`, encodeURIComponent(String(requestParameters.rid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionReportDocumentUrlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the file for a specific workflow submission report
     * Get workflow submission report file
     */
    async getSupportCollectionWorkflowSubmissionReportFile(requestParameters: GetSupportCollectionWorkflowSubmissionReportFileRequest): Promise<SubmissionReportDocumentUrlResponse> {
        const response = await this.getSupportCollectionWorkflowSubmissionReportFileRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow submission reports
     * Get workflow submission reports
     */
    async getSupportCollectionWorkflowSubmissionReportsRaw(requestParameters: GetSupportCollectionWorkflowSubmissionReportsRequest): Promise<runtime.ApiResponse<Array<WorkflowSubmissionReportItemResponse>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportCollectionWorkflowSubmissionReports.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterReportType) {
            queryParameters['filterReportType'] = requestParameters.filterReportType;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_submission/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowSubmissionReportItemResponseFromJSON));
    }

    /**
     * Retrieves a list of workflow submission reports
     * Get workflow submission reports
     */
    async getSupportCollectionWorkflowSubmissionReports(requestParameters: GetSupportCollectionWorkflowSubmissionReportsRequest): Promise<Array<WorkflowSubmissionReportItemResponse>> {
        const response = await this.getSupportCollectionWorkflowSubmissionReportsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieves a list of workflow submissions
     * Get workflow submissions
     */
    async getSupportCollectionWorkflowSubmissionsRaw(requestParameters: GetSupportCollectionWorkflowSubmissionsRequest): Promise<runtime.ApiResponse<Array<CollectionWorkflowSubmission>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterEventType) {
            queryParameters['filterEventType'] = requestParameters.filterEventType;
        }

        if (requestParameters.filterCollectionIntegrationId) {
            queryParameters['filterCollectionIntegrationId'] = requestParameters.filterCollectionIntegrationId;
        }

        if (requestParameters.filterExecutionType) {
            queryParameters['filterExecutionType'] = requestParameters.filterExecutionType;
        }

        if (requestParameters.filterSubmissionStartDate) {
            queryParameters['filterSubmissionStartDate'] = requestParameters.filterSubmissionStartDate;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_submission`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CollectionWorkflowSubmissionFromJSON));
    }

    /**
     * Retrieves a list of workflow submissions
     * Get workflow submissions
     */
    async getSupportCollectionWorkflowSubmissions(requestParameters: GetSupportCollectionWorkflowSubmissionsRequest): Promise<Array<CollectionWorkflowSubmission>> {
        const response = await this.getSupportCollectionWorkflowSubmissionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async getSupportPatientCollectionCsvExportDownloadRaw(requestParameters: GetSupportPatientCollectionCsvExportDownloadRequest): Promise<runtime.ApiResponse<CsvExportItemDocumentResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPatientCollectionCsvExportDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/export/csv/{id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CsvExportItemDocumentResponseFromJSON(jsonValue));
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async getSupportPatientCollectionCsvExportDownload(requestParameters: GetSupportPatientCollectionCsvExportDownloadRequest): Promise<CsvExportItemDocumentResponse> {
        const response = await this.getSupportPatientCollectionCsvExportDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payment plans
     * Get a list of collection payment plans
     */
    async listProviderCollectionPaymentPlansRaw(requestParameters: ListProviderCollectionPaymentPlansRequest): Promise<runtime.ApiResponse<Array<ProviderPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterInvoiceId) {
            queryParameters['filterInvoiceId'] = requestParameters.filterInvoiceId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPaymentPlanFromJSON));
    }

    /**
     * Gets a list of collection payment plans
     * Get a list of collection payment plans
     */
    async listProviderCollectionPaymentPlans(requestParameters: ListProviderCollectionPaymentPlansRequest): Promise<Array<ProviderPaymentPlan>> {
        const response = await this.listProviderCollectionPaymentPlansRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payment sources
     * Get a list of collection payment sources
     */
    async listProviderCollectionPaymentSourcesRaw(requestParameters: ListProviderCollectionPaymentSourcesRequest): Promise<runtime.ApiResponse<Array<ProviderCollectionPaymentSourceWithAllocationInfo>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPaymentDate) {
            queryParameters['filterPaymentDate'] = requestParameters.filterPaymentDate;
        }

        if (requestParameters.filterUnallocatedAmount) {
            queryParameters['filterUnallocatedAmount'] = requestParameters.filterUnallocatedAmount;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterExternalTransactionId) {
            queryParameters['filterExternalTransactionId'] = requestParameters.filterExternalTransactionId;
        }

        if (requestParameters.filterExternalVisitId) {
            queryParameters['filterExternalVisitId'] = requestParameters.filterExternalVisitId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment_source`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCollectionPaymentSourceWithAllocationInfoFromJSON));
    }

    /**
     * Gets a list of collection payment sources
     * Get a list of collection payment sources
     */
    async listProviderCollectionPaymentSources(requestParameters: ListProviderCollectionPaymentSourcesRequest): Promise<Array<ProviderCollectionPaymentSourceWithAllocationInfo>> {
        const response = await this.listProviderCollectionPaymentSourcesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listProviderCollectionPaymentsRaw(requestParameters: ListProviderCollectionPaymentsRequest): Promise<runtime.ApiResponse<Array<ProviderCollectionPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterCollectionPaymentSourceId) {
            queryParameters['filterCollectionPaymentSourceId'] = requestParameters.filterCollectionPaymentSourceId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCollectionPaymentFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listProviderCollectionPayments(requestParameters: ListProviderCollectionPaymentsRequest): Promise<Array<ProviderCollectionPayment>> {
        const response = await this.listProviderCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of refund requests
     * Get a list of refund requests
     */
    async listProviderRefundRequestsRaw(requestParameters: ListProviderRefundRequestsRequest): Promise<runtime.ApiResponse<Array<ProviderCollectionRefundRequest>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterExternalPatientId) {
            queryParameters['filterExternalPatientId'] = requestParameters.filterExternalPatientId;
        }

        if (requestParameters.filterApproveDate) {
            queryParameters['filterApproveDate'] = requestParameters.filterApproveDate;
        }

        if (requestParameters.filterDenyDate) {
            queryParameters['filterDenyDate'] = requestParameters.filterDenyDate;
        }

        if (requestParameters.filterCollectionSubmissionId) {
            queryParameters['filterCollectionSubmissionId'] = requestParameters.filterCollectionSubmissionId;
        }

        if (requestParameters.filterReconcileDate) {
            queryParameters['filterReconcileDate'] = requestParameters.filterReconcileDate;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/refund_request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCollectionRefundRequestFromJSON));
    }

    /**
     * Gets a list of refund requests
     * Get a list of refund requests
     */
    async listProviderRefundRequests(requestParameters: ListProviderRefundRequestsRequest): Promise<Array<ProviderCollectionRefundRequest>> {
        const response = await this.listProviderRefundRequestsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of claim collection invoice events
     * Get a list of claim collection invoice events
     */
    async listSupportCollectionInvoiceEventsRaw(requestParameters: ListSupportCollectionInvoiceEventsRequest): Promise<runtime.ApiResponse<Array<SupportCollectionInvoiceEvent>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/invoice_event`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCollectionInvoiceEventFromJSON));
    }

    /**
     * Gets a list of claim collection invoice events
     * Get a list of claim collection invoice events
     */
    async listSupportCollectionInvoiceEvents(requestParameters: ListSupportCollectionInvoiceEventsRequest): Promise<Array<SupportCollectionInvoiceEvent>> {
        const response = await this.listSupportCollectionInvoiceEventsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentPlansRaw(requestParameters: ListSupportCollectionPaymentPlansRequest): Promise<runtime.ApiResponse<Array<SupportPaymentPlan>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPaymentPlanFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentPlans(requestParameters: ListSupportCollectionPaymentPlansRequest): Promise<Array<SupportPaymentPlan>> {
        const response = await this.listSupportCollectionPaymentPlansRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPaymentsRaw(requestParameters: ListSupportCollectionPaymentsRequest): Promise<runtime.ApiResponse<Array<SupportCollectionPayment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterGuarantorId) {
            queryParameters['filterGuarantorId'] = requestParameters.filterGuarantorId;
        }

        if (requestParameters.filterClaimType !== undefined) {
            queryParameters['filterClaimType'] = requestParameters.filterClaimType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportCollectionPaymentFromJSON));
    }

    /**
     * Gets a list of collection payments
     * Get a list of collection payments
     */
    async listSupportCollectionPayments(requestParameters: ListSupportCollectionPaymentsRequest): Promise<Array<SupportCollectionPayment>> {
        const response = await this.listSupportCollectionPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update collection payment
     * Update collection payment
     */
    async patchProviderUpdateCollectionPaymentRaw(requestParameters: PatchProviderUpdateCollectionPaymentRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchProviderUpdateCollectionPayment.');
        }

        if (requestParameters['providerUpdateCollectionPaymentPayload'] === null || requestParameters['providerUpdateCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateCollectionPaymentPayload','Required parameter requestParameters.providerUpdateCollectionPaymentPayload was null or undefined when calling patchProviderUpdateCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateCollectionPaymentPayloadToJSON(requestParameters['providerUpdateCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Update collection payment
     * Update collection payment
     */
    async patchProviderUpdateCollectionPayment(requestParameters: PatchProviderUpdateCollectionPaymentRequest): Promise<ProviderCollectionPayment> {
        const response = await this.patchProviderUpdateCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refresh stripe
     * Refresh stripe
     */
    async postCollectionActionRefreshStripeRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:invoice", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/actions/refresh_stripe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Refresh stripe
     * Refresh stripe
     */
    async postCollectionActionRefreshStripe(): Promise<ObjectNoResponse> {
        const response = await this.postCollectionActionRefreshStripeRaw();
        return await response.value();
    }

    /**
     * Execute inbox operation request
     * Execute inbox operation request
     */
    async postExecuteSupportCollectionInboxOperationRaw(requestParameters: PostExecuteSupportCollectionInboxOperationRequest): Promise<runtime.ApiResponse<SupportCollectionInboxOperation>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postExecuteSupportCollectionInboxOperation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/inbox_operation/{id}/execute`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionInboxOperationFromJSON(jsonValue));
    }

    /**
     * Execute inbox operation request
     * Execute inbox operation request
     */
    async postExecuteSupportCollectionInboxOperation(requestParameters: PostExecuteSupportCollectionInboxOperationRequest): Promise<SupportCollectionInboxOperation> {
        const response = await this.postExecuteSupportCollectionInboxOperationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Allocate collection payment sources
     * Allocate collection payment sources
     */
    async postProviderAllocateCollectionPaymentSourceRaw(requestParameters: PostProviderAllocateCollectionPaymentSourceRequest): Promise<runtime.ApiResponse<ProviderCollectionPaymentSourceWithAllocationInfo>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderAllocateCollectionPaymentSource.');
        }

        if (requestParameters['providerAllocateCollectionPaymentSourceListPayload'] === null || requestParameters['providerAllocateCollectionPaymentSourceListPayload'] === undefined) {
            throw new runtime.RequiredError('providerAllocateCollectionPaymentSourceListPayload','Required parameter requestParameters.providerAllocateCollectionPaymentSourceListPayload was null or undefined when calling postProviderAllocateCollectionPaymentSource.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment_source/{id}/allocate`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderAllocateCollectionPaymentSourceListPayloadToJSON(requestParameters['providerAllocateCollectionPaymentSourceListPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentSourceWithAllocationInfoFromJSON(jsonValue));
    }

    /**
     * Allocate collection payment sources
     * Allocate collection payment sources
     */
    async postProviderAllocateCollectionPaymentSource(requestParameters: PostProviderAllocateCollectionPaymentSourceRequest): Promise<ProviderCollectionPaymentSourceWithAllocationInfo> {
        const response = await this.postProviderAllocateCollectionPaymentSourceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a patient account statement
     * Create patient account statement
     */
    async postProviderCollectionPatientAccountStatementRaw(requestParameters: PostProviderCollectionPatientAccountStatementRequest): Promise<runtime.ApiResponse<CreateCollectionPatientAccountStatementResponse>> {
        if (requestParameters['createCollectionPatientAccountStatementRequest'] === null || requestParameters['createCollectionPatientAccountStatementRequest'] === undefined) {
            throw new runtime.RequiredError('createCollectionPatientAccountStatementRequest','Required parameter requestParameters.createCollectionPatientAccountStatementRequest was null or undefined when calling postProviderCollectionPatientAccountStatement.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account_statement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCollectionPatientAccountStatementRequestToJSON(requestParameters['createCollectionPatientAccountStatementRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCollectionPatientAccountStatementResponseFromJSON(jsonValue));
    }

    /**
     * Creates a patient account statement
     * Create patient account statement
     */
    async postProviderCollectionPatientAccountStatement(requestParameters: PostProviderCollectionPatientAccountStatementRequest): Promise<CreateCollectionPatientAccountStatementResponse> {
        const response = await this.postProviderCollectionPatientAccountStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postProviderCollectionPaymentRefundRaw(requestParameters: PostProviderCollectionPaymentRefundRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionPaymentRefund.');
        }

        if (requestParameters['providerRefundCollectionPaymentPayload'] === null || requestParameters['providerRefundCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('providerRefundCollectionPaymentPayload','Required parameter requestParameters.providerRefundCollectionPaymentPayload was null or undefined when calling postProviderCollectionPaymentRefund.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderRefundCollectionPaymentPayloadToJSON(requestParameters['providerRefundCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postProviderCollectionPaymentRefund(requestParameters: PostProviderCollectionPaymentRefundRequest): Promise<ProviderCollectionPayment> {
        const response = await this.postProviderCollectionPaymentRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * Import patient payment source CSV
     * Import patient payment source CSV
     */
    async postProviderCollectionPaymentSourceCsvImportRaw(requestParameters: PostProviderCollectionPaymentSourceCsvImportRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['collectionPaymentSourceCsvImportRequest'] === null || requestParameters['collectionPaymentSourceCsvImportRequest'] === undefined) {
            throw new runtime.RequiredError('collectionPaymentSourceCsvImportRequest','Required parameter requestParameters.collectionPaymentSourceCsvImportRequest was null or undefined when calling postProviderCollectionPaymentSourceCsvImport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_payment_import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionPaymentSourceCsvImportRequestToJSON(requestParameters['collectionPaymentSourceCsvImportRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Import patient payment source CSV
     * Import patient payment source CSV
     */
    async postProviderCollectionPaymentSourceCsvImport(requestParameters: PostProviderCollectionPaymentSourceCsvImportRequest): Promise<ObjectNoResponse> {
        const response = await this.postProviderCollectionPaymentSourceCsvImportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a refund workflow request
     * Create a refund workflow request
     */
    async postProviderCollectionRefundWorkflowRequestCreateRaw(requestParameters: PostProviderCollectionRefundWorkflowRequestCreateRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionRefundWorkflowRequestCreate.');
        }

        if (requestParameters['createCollectionRefundWorkflowRequestPayload'] === null || requestParameters['createCollectionRefundWorkflowRequestPayload'] === undefined) {
            throw new runtime.RequiredError('createCollectionRefundWorkflowRequestPayload','Required parameter requestParameters.createCollectionRefundWorkflowRequestPayload was null or undefined when calling postProviderCollectionRefundWorkflowRequestCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/patient_account_statement/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCollectionRefundWorkflowRequestPayloadToJSON(requestParameters['createCollectionRefundWorkflowRequestPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Create a refund workflow request
     * Create a refund workflow request
     */
    async postProviderCollectionRefundWorkflowRequestCreate(requestParameters: PostProviderCollectionRefundWorkflowRequestCreateRequest): Promise<WorkflowRequest> {
        const response = await this.postProviderCollectionRefundWorkflowRequestCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a workflow hold
     * Create a workflow hold
     */
    async postProviderCollectionWorkflowHoldCreateRaw(requestParameters: PostProviderCollectionWorkflowHoldCreateRequest): Promise<runtime.ApiResponse<WorkflowHold>> {
        if (requestParameters['createCollectionWorkflowHoldPayload'] === null || requestParameters['createCollectionWorkflowHoldPayload'] === undefined) {
            throw new runtime.RequiredError('createCollectionWorkflowHoldPayload','Required parameter requestParameters.createCollectionWorkflowHoldPayload was null or undefined when calling postProviderCollectionWorkflowHoldCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_hold`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCollectionWorkflowHoldPayloadToJSON(requestParameters['createCollectionWorkflowHoldPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowHoldFromJSON(jsonValue));
    }

    /**
     * Create a workflow hold
     * Create a workflow hold
     */
    async postProviderCollectionWorkflowHoldCreate(requestParameters: PostProviderCollectionWorkflowHoldCreateRequest): Promise<WorkflowHold> {
        const response = await this.postProviderCollectionWorkflowHoldCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Remove a workflow hold by ID
     * Remove a workflow hold
     */
    async postProviderCollectionWorkflowHoldRemoveRaw(requestParameters: PostProviderCollectionWorkflowHoldRemoveRequest): Promise<runtime.ApiResponse<WorkflowHold>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionWorkflowHoldRemove.');
        }

        if (requestParameters['removeCollectionWorkflowHoldPayload'] === null || requestParameters['removeCollectionWorkflowHoldPayload'] === undefined) {
            throw new runtime.RequiredError('removeCollectionWorkflowHoldPayload','Required parameter requestParameters.removeCollectionWorkflowHoldPayload was null or undefined when calling postProviderCollectionWorkflowHoldRemove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_hold/{id}/remove`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveCollectionWorkflowHoldPayloadToJSON(requestParameters['removeCollectionWorkflowHoldPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowHoldFromJSON(jsonValue));
    }

    /**
     * Remove a workflow hold by ID
     * Remove a workflow hold
     */
    async postProviderCollectionWorkflowHoldRemove(requestParameters: PostProviderCollectionWorkflowHoldRemoveRequest): Promise<WorkflowHold> {
        const response = await this.postProviderCollectionWorkflowHoldRemoveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Approves a workflow request by ID
     * Approve workflow request
     */
    async postProviderCollectionWorkflowRequestApproveRaw(requestParameters: PostProviderCollectionWorkflowRequestApproveRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionWorkflowRequestApprove.');
        }

        if (requestParameters['workflowApproveActionRequest'] === null || requestParameters['workflowApproveActionRequest'] === undefined) {
            throw new runtime.RequiredError('workflowApproveActionRequest','Required parameter requestParameters.workflowApproveActionRequest was null or undefined when calling postProviderCollectionWorkflowRequestApprove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_request/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowApproveActionRequestToJSON(requestParameters['workflowApproveActionRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Approves a workflow request by ID
     * Approve workflow request
     */
    async postProviderCollectionWorkflowRequestApprove(requestParameters: PostProviderCollectionWorkflowRequestApproveRequest): Promise<WorkflowRequest> {
        const response = await this.postProviderCollectionWorkflowRequestApproveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Denies a workflow request by ID
     * Deny workflow request
     */
    async postProviderCollectionWorkflowRequestDenyRaw(requestParameters: PostProviderCollectionWorkflowRequestDenyRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionWorkflowRequestDeny.');
        }

        if (requestParameters['workflowDenyActionRequest'] === null || requestParameters['workflowDenyActionRequest'] === undefined) {
            throw new runtime.RequiredError('workflowDenyActionRequest','Required parameter requestParameters.workflowDenyActionRequest was null or undefined when calling postProviderCollectionWorkflowRequestDeny.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_request/{id}/deny`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowDenyActionRequestToJSON(requestParameters['workflowDenyActionRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Denies a workflow request by ID
     * Deny workflow request
     */
    async postProviderCollectionWorkflowRequestDeny(requestParameters: PostProviderCollectionWorkflowRequestDenyRequest): Promise<WorkflowRequest> {
        const response = await this.postProviderCollectionWorkflowRequestDenyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Previews a workflow submission by ID
     * Preview workflow submission
     */
    async postProviderCollectionWorkflowSubmissionPreviewRaw(requestParameters: PostProviderCollectionWorkflowSubmissionPreviewRequest): Promise<runtime.ApiResponse<WorkflowSubmissionReportResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionWorkflowSubmissionPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_submission/{id}/preview`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowSubmissionReportResponseFromJSON(jsonValue));
    }

    /**
     * Previews a workflow submission by ID
     * Preview workflow submission
     */
    async postProviderCollectionWorkflowSubmissionPreview(requestParameters: PostProviderCollectionWorkflowSubmissionPreviewRequest): Promise<WorkflowSubmissionReportResponse> {
        const response = await this.postProviderCollectionWorkflowSubmissionPreviewRaw(requestParameters);
        return await response.value();
    }

    /**
     * Submits a workflow submission by ID
     * Submit workflow submission
     */
    async postProviderCollectionWorkflowSubmissionSubmitRaw(requestParameters: PostProviderCollectionWorkflowSubmissionSubmitRequest): Promise<runtime.ApiResponse<CollectionWorkflowSubmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderCollectionWorkflowSubmissionSubmit.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/workflow_submission/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionWorkflowSubmissionFromJSON(jsonValue));
    }

    /**
     * Submits a workflow submission by ID
     * Submit workflow submission
     */
    async postProviderCollectionWorkflowSubmissionSubmit(requestParameters: PostProviderCollectionWorkflowSubmissionSubmitRequest): Promise<CollectionWorkflowSubmission> {
        const response = await this.postProviderCollectionWorkflowSubmissionSubmitRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postProviderCreateCollectionPaymentRaw(requestParameters: PostProviderCreateCollectionPaymentRequest): Promise<runtime.ApiResponse<ProviderCollectionPayment>> {
        if (requestParameters['providerCreateCollectionPaymentPayload'] === null || requestParameters['providerCreateCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateCollectionPaymentPayload','Required parameter requestParameters.providerCreateCollectionPaymentPayload was null or undefined when calling postProviderCreateCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateCollectionPaymentPayloadToJSON(requestParameters['providerCreateCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postProviderCreateCollectionPayment(requestParameters: PostProviderCreateCollectionPaymentRequest): Promise<ProviderCollectionPayment> {
        const response = await this.postProviderCreateCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create collection payment sources
     * Create collection payment sources
     */
    async postProviderCreateCollectionPaymentSourceRaw(requestParameters: PostProviderCreateCollectionPaymentSourceRequest): Promise<runtime.ApiResponse<ProviderCollectionPaymentSource>> {
        if (requestParameters['providerCreateCollectionPaymentSourcePayload'] === null || requestParameters['providerCreateCollectionPaymentSourcePayload'] === undefined) {
            throw new runtime.RequiredError('providerCreateCollectionPaymentSourcePayload','Required parameter requestParameters.providerCreateCollectionPaymentSourcePayload was null or undefined when calling postProviderCreateCollectionPaymentSource.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/payment_source`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCreateCollectionPaymentSourcePayloadToJSON(requestParameters['providerCreateCollectionPaymentSourcePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionPaymentSourceFromJSON(jsonValue));
    }

    /**
     * Create collection payment sources
     * Create collection payment sources
     */
    async postProviderCreateCollectionPaymentSource(requestParameters: PostProviderCreateCollectionPaymentSourceRequest): Promise<ProviderCollectionPaymentSource> {
        const response = await this.postProviderCreateCollectionPaymentSourceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async postProviderPatientCollectionCsvExportRaw(requestParameters: PostProviderPatientCollectionCsvExportRequest): Promise<runtime.ApiResponse<CsvExportItemResponse>> {
        if (requestParameters['collectionsCsvExportRequest'] === null || requestParameters['collectionsCsvExportRequest'] === undefined) {
            throw new runtime.RequiredError('collectionsCsvExportRequest','Required parameter requestParameters.collectionsCsvExportRequest was null or undefined when calling postProviderPatientCollectionCsvExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/export/csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionsCsvExportRequestToJSON(requestParameters['collectionsCsvExportRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CsvExportItemResponseFromJSON(jsonValue));
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async postProviderPatientCollectionCsvExport(requestParameters: PostProviderPatientCollectionCsvExportRequest): Promise<CsvExportItemResponse> {
        const response = await this.postProviderPatientCollectionCsvExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postProviderPaymentPlanRaw(requestParameters: PostProviderPaymentPlanRequest): Promise<runtime.ApiResponse<ProviderPaymentPlan>> {
        if (requestParameters['supportCreatePaymentPlanPayload'] === null || requestParameters['supportCreatePaymentPlanPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePaymentPlanPayload','Required parameter requestParameters.supportCreatePaymentPlanPayload was null or undefined when calling postProviderPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePaymentPlanPayloadToJSON(requestParameters['supportCreatePaymentPlanPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postProviderPaymentPlan(requestParameters: PostProviderPaymentPlanRequest): Promise<ProviderPaymentPlan> {
        const response = await this.postProviderPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create inbox operation request
     * Create inbox operation request
     */
    async postSupportCollectionInboxOperationRaw(requestParameters: PostSupportCollectionInboxOperationRequest): Promise<runtime.ApiResponse<SupportCollectionInboxOperation>> {
        if (requestParameters['supportCollectionInboxOperationRequest'] === null || requestParameters['supportCollectionInboxOperationRequest'] === undefined) {
            throw new runtime.RequiredError('supportCollectionInboxOperationRequest','Required parameter requestParameters.supportCollectionInboxOperationRequest was null or undefined when calling postSupportCollectionInboxOperation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/inbox_operation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCollectionInboxOperationRequestToJSON(requestParameters['supportCollectionInboxOperationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionInboxOperationFromJSON(jsonValue));
    }

    /**
     * Create inbox operation request
     * Create inbox operation request
     */
    async postSupportCollectionInboxOperation(requestParameters: PostSupportCollectionInboxOperationRequest): Promise<SupportCollectionInboxOperation> {
        const response = await this.postSupportCollectionInboxOperationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a patient account statement
     * Create patient account statement
     */
    async postSupportCollectionPatientAccountStatementRaw(requestParameters: PostSupportCollectionPatientAccountStatementRequest): Promise<runtime.ApiResponse<CreateCollectionPatientAccountStatementResponse>> {
        if (requestParameters['supportCreateCollectionPatientAccountStatementRequest'] === null || requestParameters['supportCreateCollectionPatientAccountStatementRequest'] === undefined) {
            throw new runtime.RequiredError('supportCreateCollectionPatientAccountStatementRequest','Required parameter requestParameters.supportCreateCollectionPatientAccountStatementRequest was null or undefined when calling postSupportCollectionPatientAccountStatement.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account_statement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateCollectionPatientAccountStatementRequestToJSON(requestParameters['supportCreateCollectionPatientAccountStatementRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateCollectionPatientAccountStatementResponseFromJSON(jsonValue));
    }

    /**
     * Creates a patient account statement
     * Create patient account statement
     */
    async postSupportCollectionPatientAccountStatement(requestParameters: PostSupportCollectionPatientAccountStatementRequest): Promise<CreateCollectionPatientAccountStatementResponse> {
        const response = await this.postSupportCollectionPatientAccountStatementRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable collection payment
     * Disable collection payment
     */
    async postSupportCollectionPaymentDisableRaw(requestParameters: PostSupportCollectionPaymentDisableRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionPaymentDisable.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Disable collection payment
     * Disable collection payment
     */
    async postSupportCollectionPaymentDisable(requestParameters: PostSupportCollectionPaymentDisableRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCollectionPaymentDisableRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postSupportCollectionPaymentRefundRaw(requestParameters: PostSupportCollectionPaymentRefundRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionPaymentRefund.');
        }

        if (requestParameters['supportRefundCollectionPaymentPayload'] === null || requestParameters['supportRefundCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportRefundCollectionPaymentPayload','Required parameter requestParameters.supportRefundCollectionPaymentPayload was null or undefined when calling postSupportCollectionPaymentRefund.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRefundCollectionPaymentPayloadToJSON(requestParameters['supportRefundCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Refund collection payment
     * Refund collection payment
     */
    async postSupportCollectionPaymentRefund(requestParameters: PostSupportCollectionPaymentRefundRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCollectionPaymentRefundRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a refund workflow request
     * Create a refund workflow request
     */
    async postSupportCollectionRefundWorkflowRequestCreateRaw(requestParameters: PostSupportCollectionRefundWorkflowRequestCreateRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionRefundWorkflowRequestCreate.');
        }

        if (requestParameters['createCollectionRefundWorkflowRequestPayload'] === null || requestParameters['createCollectionRefundWorkflowRequestPayload'] === undefined) {
            throw new runtime.RequiredError('createCollectionRefundWorkflowRequestPayload','Required parameter requestParameters.createCollectionRefundWorkflowRequestPayload was null or undefined when calling postSupportCollectionRefundWorkflowRequestCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/patient_account_statement/{id}/refund`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCollectionRefundWorkflowRequestPayloadToJSON(requestParameters['createCollectionRefundWorkflowRequestPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Create a refund workflow request
     * Create a refund workflow request
     */
    async postSupportCollectionRefundWorkflowRequestCreate(requestParameters: PostSupportCollectionRefundWorkflowRequestCreateRequest): Promise<WorkflowRequest> {
        const response = await this.postSupportCollectionRefundWorkflowRequestCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a workflow hold
     * Create a workflow hold
     */
    async postSupportCollectionWorkflowHoldCreateRaw(requestParameters: PostSupportCollectionWorkflowHoldCreateRequest): Promise<runtime.ApiResponse<WorkflowHold>> {
        if (requestParameters['createCollectionWorkflowHoldPayload'] === null || requestParameters['createCollectionWorkflowHoldPayload'] === undefined) {
            throw new runtime.RequiredError('createCollectionWorkflowHoldPayload','Required parameter requestParameters.createCollectionWorkflowHoldPayload was null or undefined when calling postSupportCollectionWorkflowHoldCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_hold`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCollectionWorkflowHoldPayloadToJSON(requestParameters['createCollectionWorkflowHoldPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowHoldFromJSON(jsonValue));
    }

    /**
     * Create a workflow hold
     * Create a workflow hold
     */
    async postSupportCollectionWorkflowHoldCreate(requestParameters: PostSupportCollectionWorkflowHoldCreateRequest): Promise<WorkflowHold> {
        const response = await this.postSupportCollectionWorkflowHoldCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Remove a workflow hold by ID
     * Remove a workflow hold
     */
    async postSupportCollectionWorkflowHoldRemoveRaw(requestParameters: PostSupportCollectionWorkflowHoldRemoveRequest): Promise<runtime.ApiResponse<WorkflowHold>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowHoldRemove.');
        }

        if (requestParameters['removeCollectionWorkflowHoldPayload'] === null || requestParameters['removeCollectionWorkflowHoldPayload'] === undefined) {
            throw new runtime.RequiredError('removeCollectionWorkflowHoldPayload','Required parameter requestParameters.removeCollectionWorkflowHoldPayload was null or undefined when calling postSupportCollectionWorkflowHoldRemove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_hold/{id}/remove`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveCollectionWorkflowHoldPayloadToJSON(requestParameters['removeCollectionWorkflowHoldPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowHoldFromJSON(jsonValue));
    }

    /**
     * Remove a workflow hold by ID
     * Remove a workflow hold
     */
    async postSupportCollectionWorkflowHoldRemove(requestParameters: PostSupportCollectionWorkflowHoldRemoveRequest): Promise<WorkflowHold> {
        const response = await this.postSupportCollectionWorkflowHoldRemoveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Approves a workflow request by ID
     * Approve workflow request
     */
    async postSupportCollectionWorkflowRequestApproveRaw(requestParameters: PostSupportCollectionWorkflowRequestApproveRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowRequestApprove.');
        }

        if (requestParameters['workflowApproveActionRequest'] === null || requestParameters['workflowApproveActionRequest'] === undefined) {
            throw new runtime.RequiredError('workflowApproveActionRequest','Required parameter requestParameters.workflowApproveActionRequest was null or undefined when calling postSupportCollectionWorkflowRequestApprove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_request/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowApproveActionRequestToJSON(requestParameters['workflowApproveActionRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Approves a workflow request by ID
     * Approve workflow request
     */
    async postSupportCollectionWorkflowRequestApprove(requestParameters: PostSupportCollectionWorkflowRequestApproveRequest): Promise<WorkflowRequest> {
        const response = await this.postSupportCollectionWorkflowRequestApproveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Denies a workflow request by ID
     * Deny workflow request
     */
    async postSupportCollectionWorkflowRequestDenyRaw(requestParameters: PostSupportCollectionWorkflowRequestDenyRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowRequestDeny.');
        }

        if (requestParameters['workflowDenyActionRequest'] === null || requestParameters['workflowDenyActionRequest'] === undefined) {
            throw new runtime.RequiredError('workflowDenyActionRequest','Required parameter requestParameters.workflowDenyActionRequest was null or undefined when calling postSupportCollectionWorkflowRequestDeny.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_request/{id}/deny`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WorkflowDenyActionRequestToJSON(requestParameters['workflowDenyActionRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Denies a workflow request by ID
     * Deny workflow request
     */
    async postSupportCollectionWorkflowRequestDeny(requestParameters: PostSupportCollectionWorkflowRequestDenyRequest): Promise<WorkflowRequest> {
        const response = await this.postSupportCollectionWorkflowRequestDenyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Links a message to a workflow request by ID
     * Link message to workflow request
     */
    async postSupportCollectionWorkflowRequestMessageLinkRaw(requestParameters: PostSupportCollectionWorkflowRequestMessageLinkRequest): Promise<runtime.ApiResponse<WorkflowRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowRequestMessageLink.');
        }

        if (requestParameters['supportWorkflowMessageLinkRequest'] === null || requestParameters['supportWorkflowMessageLinkRequest'] === undefined) {
            throw new runtime.RequiredError('supportWorkflowMessageLinkRequest','Required parameter requestParameters.supportWorkflowMessageLinkRequest was null or undefined when calling postSupportCollectionWorkflowRequestMessageLink.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_request/{id}/message_link`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportWorkflowMessageLinkRequestToJSON(requestParameters['supportWorkflowMessageLinkRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowRequestFromJSON(jsonValue));
    }

    /**
     * Links a message to a workflow request by ID
     * Link message to workflow request
     */
    async postSupportCollectionWorkflowRequestMessageLink(requestParameters: PostSupportCollectionWorkflowRequestMessageLinkRequest): Promise<WorkflowRequest> {
        const response = await this.postSupportCollectionWorkflowRequestMessageLinkRaw(requestParameters);
        return await response.value();
    }

    /**
     * Previews a workflow submission by ID
     * Preview workflow submission
     */
    async postSupportCollectionWorkflowSubmissionPreviewRaw(requestParameters: PostSupportCollectionWorkflowSubmissionPreviewRequest): Promise<runtime.ApiResponse<WorkflowSubmissionReportResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowSubmissionPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_submission/{id}/preview`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowSubmissionReportResponseFromJSON(jsonValue));
    }

    /**
     * Previews a workflow submission by ID
     * Preview workflow submission
     */
    async postSupportCollectionWorkflowSubmissionPreview(requestParameters: PostSupportCollectionWorkflowSubmissionPreviewRequest): Promise<WorkflowSubmissionReportResponse> {
        const response = await this.postSupportCollectionWorkflowSubmissionPreviewRaw(requestParameters);
        return await response.value();
    }

    /**
     * Submits a workflow submission by ID
     * Submit workflow submission
     */
    async postSupportCollectionWorkflowSubmissionSubmitRaw(requestParameters: PostSupportCollectionWorkflowSubmissionSubmitRequest): Promise<runtime.ApiResponse<CollectionWorkflowSubmission>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportCollectionWorkflowSubmissionSubmit.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "update:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/workflow_submission/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CollectionWorkflowSubmissionFromJSON(jsonValue));
    }

    /**
     * Submits a workflow submission by ID
     * Submit workflow submission
     */
    async postSupportCollectionWorkflowSubmissionSubmit(requestParameters: PostSupportCollectionWorkflowSubmissionSubmitRequest): Promise<CollectionWorkflowSubmission> {
        const response = await this.postSupportCollectionWorkflowSubmissionSubmitRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postSupportCreateCollectionPaymentRaw(requestParameters: PostSupportCreateCollectionPaymentRequest): Promise<runtime.ApiResponse<SupportCollectionPayment>> {
        if (requestParameters['supportCreateCollectionPaymentPayload'] === null || requestParameters['supportCreateCollectionPaymentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateCollectionPaymentPayload','Required parameter requestParameters.supportCreateCollectionPaymentPayload was null or undefined when calling postSupportCreateCollectionPayment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateCollectionPaymentPayloadToJSON(requestParameters['supportCreateCollectionPaymentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportCollectionPaymentFromJSON(jsonValue));
    }

    /**
     * Create collection payment
     * Create collection payment
     */
    async postSupportCreateCollectionPayment(requestParameters: PostSupportCreateCollectionPaymentRequest): Promise<SupportCollectionPayment> {
        const response = await this.postSupportCreateCollectionPaymentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async postSupportPatientCollectionCsvExportRaw(requestParameters: PostSupportPatientCollectionCsvExportRequest): Promise<runtime.ApiResponse<CsvExportItemResponse>> {
        if (requestParameters['collectionsCsvExportRequest'] === null || requestParameters['collectionsCsvExportRequest'] === undefined) {
            throw new runtime.RequiredError('collectionsCsvExportRequest','Required parameter requestParameters.collectionsCsvExportRequest was null or undefined when calling postSupportPatientCollectionCsvExport.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support", "read:claim"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/export/csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionsCsvExportRequestToJSON(requestParameters['collectionsCsvExportRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CsvExportItemResponseFromJSON(jsonValue));
    }

    /**
     * Export patient collection CSV
     * Export patient collection CSV
     */
    async postSupportPatientCollectionCsvExport(requestParameters: PostSupportPatientCollectionCsvExportRequest): Promise<CsvExportItemResponse> {
        const response = await this.postSupportPatientCollectionCsvExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * Submit patient collection CSV
     * Submit patient collection CSV
     */
    async postSupportPatientCollectionCsvSubmissionRaw(requestParameters: PostSupportPatientCollectionCsvSubmissionRequest): Promise<runtime.ApiResponse<CsvExportItemResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportPatientCollectionCsvSubmission.');
        }

        if (requestParameters['collectionCsvSubmissionRequest'] === null || requestParameters['collectionCsvSubmissionRequest'] === undefined) {
            throw new runtime.RequiredError('collectionCsvSubmissionRequest','Required parameter requestParameters.collectionCsvSubmissionRequest was null or undefined when calling postSupportPatientCollectionCsvSubmission.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:claim", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/export/csv/{id}/submit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CollectionCsvSubmissionRequestToJSON(requestParameters['collectionCsvSubmissionRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => CsvExportItemResponseFromJSON(jsonValue));
    }

    /**
     * Submit patient collection CSV
     * Submit patient collection CSV
     */
    async postSupportPatientCollectionCsvSubmission(requestParameters: PostSupportPatientCollectionCsvSubmissionRequest): Promise<CsvExportItemResponse> {
        const response = await this.postSupportPatientCollectionCsvSubmissionRaw(requestParameters);
        return await response.value();
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postSupportPaymentPlanRaw(requestParameters: PostSupportPaymentPlanRequest): Promise<runtime.ApiResponse<SupportPaymentPlan>> {
        if (requestParameters['supportCreatePaymentPlanPayload'] === null || requestParameters['supportCreatePaymentPlanPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePaymentPlanPayload','Required parameter requestParameters.supportCreatePaymentPlanPayload was null or undefined when calling postSupportPaymentPlan.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/collection/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePaymentPlanPayloadToJSON(requestParameters['supportCreatePaymentPlanPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPaymentPlanFromJSON(jsonValue));
    }

    /**
     * Generate payment plan
     * Generate payment plan
     */
    async postSupportPaymentPlan(requestParameters: PostSupportPaymentPlanRequest): Promise<SupportPaymentPlan> {
        const response = await this.postSupportPaymentPlanRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unapprove refund request
     * Unapprove the refund request
     */
    async unapproveProviderRefundRequestRaw(requestParameters: UnapproveProviderRefundRequestRequest): Promise<runtime.ApiResponse<ProviderCollectionRefundRequest>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling unapproveProviderRefundRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/collection/refund_request/{id}/unapprove`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCollectionRefundRequestFromJSON(jsonValue));
    }

    /**
     * Unapprove refund request
     * Unapprove the refund request
     */
    async unapproveProviderRefundRequest(requestParameters: UnapproveProviderRefundRequestRequest): Promise<ProviderCollectionRefundRequest> {
        const response = await this.unapproveProviderRefundRequestRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionPatientAccountStatementsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionPatientAccountsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionWorkflowHoldsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionWorkflowRequestsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionWorkflowSubmissionReportsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderCollectionWorkflowSubmissionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionPatientAccountStatementsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionPatientAccountsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionWorkflowHoldsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionWorkflowRequestsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionWorkflowSubmissionReportsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportCollectionWorkflowSubmissionsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentSourcesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderCollectionPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderRefundRequestsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionInvoiceEventsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentPlansOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportCollectionPaymentsFilterClaimTypeEnum {
    PROFESSIONAL = 'PROFESSIONAL',
    INSTITUTIONAL = 'INSTITUTIONAL',
    DENTAL = 'DENTAL',
    NYNF3 = 'NYNF3'
}
